"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(id, parameters = {}) {
    const params = Object.entries(parameters).map(([key, value]) => `[${key}:${value}]`);
    const paramString = params.join("/");
    const token = `${id.toLowerCase()}::${paramString}`;
    return token;
}
exports.default = default_1;
//# sourceMappingURL=CreateDictionaryHash.js.map